import { Tag } from "antd";
import React, { useEffect } from "react";
import AntTable from "../../../components/AntTable";
import ExportButton from "../../../components/Styles/ExportButton";
// import Tag from "../../../components/Styles/Tags";
import ApiWrapper from "../../../utils/ApiWrapper";

const MappedSkUs = (props) => {
  const { dataSource, isLoading, isDataLoading } = props;

  const unMapProductToSKU = async (record) => {
    let requestJsonBody = {
      listings: [
        {
          masterSKU: record.masterSKU,
          channel: record.marketplace,
          sku: record.sku,
          isMap: false,
        },
      ],
    };
    ApiWrapper("updateMasterSKU", requestJsonBody).then(
      function (response) {
        if (response.status) {
          props.refreshList();
        }
      },
      function (error) {
        // message.error(
        //   "We encountered an issue. Please log out and log back in. "
        // );
      }
    );
  };

  const columns = [
    {
      title: "Sno",
      field: "marketplace",
      width: 60,
      render: (record, rowIndex) => rowIndex,
    },
    {
      title: "Channel",
      field: "marketplace",
      width: 75,
      render: (record, rowIndex, isLoading) =>
        record.marketplace === "Amazon-India" ? (
          <div className="amazon-logo-small" />
        ) : record.marketplace === "Flipkart" ? (
          <div className="flipkart-logo-small" />
        ) : null,
    },
    {
      title: "Master SKU",
      field: "masterSKU",
      render: (record, rowIndex, isLoading) => record.masterSKU || "-",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        a = (a.masterSKU || "").toLowerCase();
        b = (b.masterSKU || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "SKU Code",
      field: "sku",
      render: (record, rowIndex, isLoading) => record.sku || "-",
      sorter: (a, b) => {
        a = (a.sku || "").toLowerCase();
        b = (b.sku || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Product ID",
      field: "productId",
      render: (record, rowIndex, isLoading) => record.productId || "-",
      sorter: (a, b) => {
        a = (a.masterSKU || "").toLowerCase();
        b = (b.masterSKU || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Product",
      field: "name",
      tooltip: true,
      render: (record, rowIndex, isLoading) =>
        record.name ? record["name"].replace(/(.{25})..+/, "$1…") : "-",
      sorter: (a, b) => {
        a = (a.name || "").toLowerCase();
        b = (b.name || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Listing Status",
      field: "status",
      render: (record, rowIndex, isLoading) => (
        <Tag
          color={
            (record.status || "").toLowerCase() === "active" ? "green" : "red"
          }
          className="capitalize"
        >
          {(record.status || "").toLowerCase()}
        </Tag>
      ),
      onFilter: (value, record) => {
        if (value === "-") {
          if (!record.status) {
            return true;
          }
        } else {
          return (record.status || "").toLowerCase() === value.toLowerCase();
        }
      },
      filters: [
        { text: "Active", value: "active" },
        { text: "Inactive", value: "inactive" },
      ],
    },
    {
      title: "",
      field: "Listing Status",
      align: "left",
      // width: "15%",
      render: (record, rowIndex, isLoading) => (
        <ExportButton
          variant="outlined"
          onClick={() => unMapProductToSKU(record)}
        >
          <div className="text-sm">Unmap Product</div>
        </ExportButton>
      ),
    },
  ];

  useEffect(() => {
    if (props.activeTab === 1) {
      props.setColumn(columns);
    }
  }, [props.activeTab]);
  return (
    <>
      <AntTable
        columns={columns}
        dataSource={dataSource}
        stickyHeader={{
          offsetHeader: 65,
          // offsetScroll: 216,
        }}
        // scroll={{ y: 500 }}
        rowKey={(row, rowIndex) => rowIndex}
        isLoading={isLoading}
        isDataLoading={isDataLoading}
        searchText={[props.searchText]}
        hideSummary
      />
    </>
  );
};

export default MappedSkUs;
